var _defs, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarNoShadow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10.0242,
    height: 26.739941,
    viewBox: "0 0 10.0242 26.739941",
    fill: "none",
    id: "svg22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs26"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2650_18555",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 41,
    height: 41
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.0966,
    height: 40.109901,
    fill: "#d9d9d9",
    id: "rect15",
    x: 0,
    y: 0
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2650_18555)",
    id: "g20",
    transform: "translate(-15.0361,-6.68506)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 20.0482,12.5344 c -0.8075,0 -1.4967,-0.2855 -2.0675,-0.8565 -0.5708,-0.571 -0.8562,-1.2604 -0.8562,-2.06816 0,-0.80777 0.2854,-1.49716 0.8562,-2.06817 0.5708,-0.57101 1.26,-0.85651 2.0675,-0.85651 0.8075,0 1.4967,0.2855 2.0675,0.85651 0.5708,0.57101 0.8562,1.2604 0.8562,2.06817 0,0.80776 -0.2854,1.49716 -0.8562,2.06816 -0.5708,0.571 -1.26,0.8565 -2.0675,0.8565 z M 16.7068,33.425 v -8.3562 h -1.6707 v -7.5206 c 0,-0.9192 0.3272,-1.7061 0.9816,-2.3607 0.6543,-0.6546 1.4409,-0.9818 2.3598,-0.9818 h 3.3414 c 0.9189,0 1.7055,0.3272 2.3599,0.9818 0.6543,0.6546 0.9815,1.4415 0.9815,2.3607 v 7.5206 h -1.6707 v 8.3562 z",
    fill: "#ff6464",
    id: "path18"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarNoShadow);
export default __webpack_public_path__ + "static/media/avatar_no_shadow.f9f09305e1297b6af30f9cfd3fb18f73.svg";
export { ForwardRef as ReactComponent };